
    <template>
      <div style="margin-top:20px">

        <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
          <span style="font-size: 26px; font-weight: bold">Booking & Actuals Processing Settings</span><br/>
        </div>

        <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
          <form @submit.prevent="save_config">
            <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
              <tr>
                <td align="right" width="500">Enabled</td>
                <td width="800"><b-form-select v-model="model.actuals_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Skip Contract Bookings</td>
                <td width="800"><b-form-select v-model="model.actuals_skip_contract_bookings" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Feed Issues Email Recipient</td>
                <td width="800"><b-form-input v-model="model.actuals_booking_feed_issues_email_recipients" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Feed Issues Hours Since Updates To Alert On</td>
                <td width="800">
                  <b-form-input v-model="model.actuals_booking_feed_issues_hours_since" type="text" :state="numericState('actuals_booking_feed_issues_hours_since')" @input="validateNumeric('actuals_booking_feed_issues_hours_since', $event, 1, 168)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('actuals_booking_feed_issues_hours_since')">{{ numericFeedback('actuals_booking_feed_issues_hours_since') }}</b-form-invalid-feedback>
                </td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Feed Issues - Ignore Private Hires</td>
                <td width="800"><b-form-select v-model="model.booking_flow_skip_privates" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Feed Issues - Ignore Contracts</td>
                <td width="800"><b-form-select v-model="model.booking_flow_skip_contracts" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='CM'">
                <td align="right" width="500">Exclude Non Diary Bookings</td>
                <td width="800"><b-form-select v-model="model.actuals_exclude_non_diary_bookings" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='TBN'">
                <td align="right" width="500">Skip Bookings Without Vehicles Assigned</td>
                <td width="800"><b-form-select v-model="model.actuals_skip_bookings_without_vehicles" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Excluded Booking Types</td>
                <td width="800"><b-form-input v-model="model.actuals_excluded_booking_types" type="text" :state="filterState('actuals_excluded_booking_types')" @input="validateFilter('actuals_excluded_booking_types', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('actuals_excluded_booking_types')">{{ filterFeedback('actuals_excluded_booking_types') }}</b-form-invalid-feedback></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Excluded Booking Vehicles</td>
                <td width="800"><b-form-input v-model="model.actuals_excluded_booking_vehicles" type="text" :state="filterState('actuals_excluded_booking_vehicles')" @input="validateFilter('actuals_excluded_booking_vehicles', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('actuals_excluded_booking_vehicles')">{{ filterFeedback('actuals_excluded_booking_vehicles') }}</b-form-invalid-feedback></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Vehicle Type Filter</td>
                <td width="800"><b-form-input v-model="model.actuals_vehicle_type_filter" type="text" :state="filterState('actuals_vehicle_type_filter')" @input="validateFilter('actuals_vehicle_type_filter', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('actuals_vehicle_type_filter')">{{ filterFeedback('actuals_vehicle_type_filter') }}</b-form-invalid-feedback></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='CM'">
                <td align="right" width="500">Client ID Filter</td>
                <td width="800"><b-form-input v-model="model.actuals_client_id_filter" type="text" :state="filterState('actuals_client_id_filter')" @input="validateFilter('actuals_client_id_filter', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('actuals_client_id_filter')">{{ filterFeedback('actuals_client_id_filter') }}</b-form-invalid-feedback></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Contract ID Filter</td>
                <td width="800"><b-form-input v-model="model.actuals_contract_id_filter" type="text" :state="filterState('actuals_contract_id_filter')" @input="validateFilter('actuals_contract_id_filter', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('actuals_contract_id_filter')">{{ filterFeedback('actuals_contract_id_filter') }}</b-form-invalid-feedback></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Excluded Booking Bases</td>
                <td width="800"><b-form-input v-model="model.actuals_excluded_booking_bases" type="text" :state="filterState('actuals_excluded_booking_bases')" @input="validateFilter('actuals_excluded_booking_bases', $event)"></b-form-input>
                <b-form-invalid-feedback :state="filterState('actuals_excluded_booking_bases')">{{ filterFeedback('actuals_excluded_booking_bases') }}</b-form-invalid-feedback></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="is_admin">
                <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">+ Advanced</span></td>
                <td></td>
                <td></td>
              </tr>
              <template v-if="toggle.isAdvVisible">
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Include Off Duty / Assigned To Vehicle Times In Actuals</td>
                  <td width="800"><b-form-select v-model="model.actuals_include_off_duty_assigned_time" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Fall Back To Vehicle Times</td>
                  <td width="800"><b-form-select v-model="model.actuals_fall_back_to_vehicle_times" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Use Spot Time As Pickup Time</td>
                  <td width="800"><b-form-select v-model="model.actuals_use_spot_time_as_pickup_time" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Use Depart Time As Dropoff Time</td>
                  <td width="800"><b-form-select v-model="model.actuals_use_depart_time_as_dropoff_time" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Fall Back To Vehicle Time (Scheduled Services)</td>
                  <td width="800"><b-form-select v-model="model.actuals_fall_back_to_vehicle_times_scheduled_services" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Fall Back To Vehicle Time (Scheduled Services)</td>
                  <td width="800"><b-form-select v-model="model.actuals_fall_back_to_vehicle_times_scheduled_services" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Only Populate Live Hours (No Dead, Wait, Driving)</td>
                  <td width="800"><b-form-select v-model="model.actuals_only_live_hours" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'TBN'">
                  <td align="right" width="500">Flat Hours For Multiday Middle Days</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_multiday_flat_hours" type="text" :state="numericState('actuals_multiday_flat_hours')" @input="validateNumeric('actuals_multiday_flat_hours', $event, 0, 24)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_multiday_flat_hours')">{{ numericFeedback('actuals_multiday_flat_hours') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'CM'">
                  <td align="right" width="500">Use Back Arrival Time</td>
                  <td width="800"><b-form-select v-model="model.actuals_use_back_arrival_time" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'CM'">
                  <td align="right" width="500">Extend Search Range For Multiday</td>
                  <td width="800"><b-form-select v-model="model.actuals_extend_search_range_for_multiday" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Date Time Format</td>
                  <td width="800"><b-form-input v-model="model.actuals_date_time_format" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'CM'">
                  <td align="right" width="500">Allow Partial Actuals</td>
                  <td width="800"><b-form-select v-model="model.actuals_allow_partial_actuals" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type === 'CM'">
                  <td align="right" width="500">Enable Pickup & Dropoff Actuals</td>
                  <td width="800"><b-form-select v-model="model.actuals_allow_pickup_dropoff_actuals" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Check For Adjacent Bookings</td>
                  <td width="800"><b-form-select v-model="model.actuals_check_for_adjacent_bookings" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Check For Overlapping Driver Logs</td>
                  <td width="800"><b-form-select v-model="model.actuals_check_for_overlapping_driver_logs" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Check For Overlapping Vehicle Events</td>
                  <td width="800"><b-form-select v-model="model.actuals_check_for_overlapping_vehicle_events" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Skip Scheduled Services</td>
                  <td width="800"><b-form-select v-model="model.actuals_skip_scheduled_services" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Disable Actuals Mileage</td>
                  <td width="800"><b-form-select v-model="model.actuals_mileage_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Email Recipients</td>
                  <td width="800"><b-form-input v-model="model.actuals_email_recipients" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Finish Time Offset Config</td>
                  <td width="800"><b-form-input v-model="model.actuals_finish_time_offset_config" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Send Actuals To TBN Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_outbound_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Outbound Booking Disabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_outbound_bookings_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Outbound Scheduled Services Disabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_outbound_scheduled_services_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Use Telematics Geofences</td>
                  <td width="800"><b-form-select v-model="model.actuals_use_eld_geofences" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Supports Live & Dead Mileage</td>
                  <td width="800"><b-form-select v-model="model.actuals_supports_live_dead_mileage" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Filter Bookings By Company</td>
                  <td width="800"><b-form-select v-model="model.actuals_filter_bookings_view_by_company" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Driver HOS Required</td>
                  <td width="800"><b-form-select v-model="model.actuals_driver_hos_required_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="telematics_type == 'SAMSARA'">
                  <td align="right" width="500">Pull DVIR Data</td>
                  <td width="800"><b-form-select v-model="model.actuals_use_dvirs_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Supports Booking By Vehicle Company</td>
                  <td width="800"><b-form-select v-model="model.actuals_supports_booking_by_vehicle_company" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Ignore Missing Segment Locations</td>
                  <td width="800"><b-form-select v-model="model.actuals_ignore_missing_segment_locations" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'CM'">
                  <td align="right" width="500" >Ignore Booking If Missing Vehicle</td>
                  <td width="800"><b-form-select v-model="model.actuals_ignore_booking_if_vehicle_is_missing" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'CM'">
                  <td align="right" width="500">Ignore Missing Mileage</td>
                  <td width="800"><b-form-select v-model="model.actuals_ignore_missing_mileage" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'CM'">
                  <td align="right" width="500">Process Days Ago Limit</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_process_days_ago_limit" type="text" :state="numericState('actuals_process_days_ago_limit')" @input="validateNumeric('actuals_process_days_ago_limit', $event, 30, 360)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_process_days_ago_limit')">{{ numericFeedback('actuals_process_days_ago_limit') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Actuals Base Config</td>
                  <td width="800"><JsonTagListEditor v-model="model.actuals_base_config" fieldKey="actuals_base_config" @validation="onJsonValidation" :allow-raw-json="is_admin" valueLabel="Base Name" placeholder="e.g. Main"/>
                      <b-form-invalid-feedback :state="jsonState('actuals_base_config')">{{ jsonFeedback('actuals_base_config') }}</b-form-invalid-feedback></td>
                  <td width="250">only process actuals for these bases</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Outbound Base Config</td>
                  <td width="800"><JsonTagListEditor v-model="model.actuals_outbound_base_config" fieldKey="actuals_outbound_base_config" @validation="onJsonValidation" :allow-raw-json="is_admin" valueLabel="Base Name" placeholder="e.g. Main"/>
                      <b-form-invalid-feedback :state="jsonState('actuals_outbound_base_config')">{{ jsonFeedback('actuals_outbound_base_config') }}</b-form-invalid-feedback></td>
                  <td width="250">only send actuals to TBN for these bases</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Outbound Auto Verify Config</td>
                  <td width="800"><JsonObjectListEditor v-model="model.actuals_outbound_auto_verify_config" fieldKey="actuals_outbound_auto_verify_config" @validation="onJsonValidation" :allow-raw-json="is_admin" :columns="auto_verify_columns"/>
                      <b-form-invalid-feedback :state="jsonState('actuals_outbound_auto_verify_config')">{{ jsonFeedback('actuals_outbound_auto_verify_config') }}</b-form-invalid-feedback></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type == 'TBN'">
                  <td align="right" width="500">Outbound Skip If Manual Actuals Found</td>
                  <td width="800"><b-form-select v-model="model.actuals_outbound_skip_if_manual_actuals_found" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Default Geofence Meters</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_default_geofence_meters" type="text" :state="numericState('actuals_default_geofence_meters')" @input="validateNumeric('actuals_default_geofence_meters', $event, 1, 100000)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_default_geofence_meters')">{{ numericFeedback('actuals_default_geofence_meters') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">HOS Active Statuses</td>
                  <td width="800"><b-form-input v-model="model.actuals_hos_active_statuses" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Support Booking Bases</td>
                  <td width="800"><b-form-input v-model="model.actuals_supported_booking_bases" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='CM'">
                  <td align="right" width="500">Supports Client IDs</td>
                  <td width="800"><b-form-input v-model="model.actuals_supported_client_ids" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Scheduled Services Filter</td>
                  <td width="800"><b-form-input v-model="model.actuals_scheduled_services_filter" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Minutes After Finish Time To Process Actuals</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_processing_delay_in_minutes" type="text" :state="numericState('actuals_processing_delay_in_minutes')" @input="validateNumeric('actuals_processing_delay_in_minutes', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_processing_delay_in_minutes')">{{ numericFeedback('actuals_processing_delay_in_minutes') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Replace Vehicle/Driver With Telematics Values</td>
                  <td width="800"><b-form-select v-model="model.booking_replace_with_eld_values" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Skip Duplicate Bookings Updates</td>
                  <td width="800"><b-form-select v-model="model.actuals_skip_duplicate_booking_updates" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Prime Locations & HOS</td>
                  <td width="800"><b-form-select v-model="model.actuals_prime_locations_and_hos" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Refresh Bookings Disabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_refresh_bookings_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Process Actuals By Yard</td>
                  <td width="800"><b-form-select v-model="model.actuals_process_by_yard" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Refresh Bookings Nightly Disabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_refresh_bookings_nightly_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Sync Drivers Disabled</td>
                  <td width="800"><b-form-select v-model="model.tbn_sync_drivers_skip" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Sync Drivers Basic Enabled</td>
                  <td width="800"><b-form-select v-model="model.tbn_sync_drivers_basic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Sync Vehicles Disabled</td>
                  <td width="800"><b-form-select v-model="model.tbn_sync_vehicles_skip" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Days In The Future</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_refresh_booking_days_in_future" type="text" :state="numericState('actuals_refresh_booking_days_in_future')" @input="validateNumeric('actuals_refresh_booking_days_in_future', $event, 0, 365)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_refresh_booking_days_in_future')">{{ numericFeedback('actuals_refresh_booking_days_in_future') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Refresh Minutes Past The Hour</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_refresh_bookings_minutes_past_the_hour" type="text" :state="numericState('actuals_refresh_bookings_minutes_past_the_hour')" @input="validateNumeric('actuals_refresh_bookings_minutes_past_the_hour', $event, 0, 59)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_refresh_bookings_minutes_past_the_hour')">{{ numericFeedback('actuals_refresh_bookings_minutes_past_the_hour') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Force Outbound Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_force_outbound_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Force Booking Updates Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_force_booking_updates_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Save Booking History Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_save_booking_history_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='CM'">
                  <td align="right" width="500">Max Days Ago To Process Bookings</td>
                  <td width="800">
                    <b-form-input v-model="model.actuals_max_days_ago" type="text" :state="numericState('actuals_max_days_ago')" @input="validateNumeric('actuals_max_days_ago', $event, 0, 365)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('actuals_max_days_ago')">{{ numericFeedback('actuals_max_days_ago') }}</b-form-invalid-feedback>
                  </td>
                  <td width="250">&nbsp;</td>
                </tr>

              </template>
            </table>

            <hr/>
            <div style="position: relative" class="d-flex align-items-center justify-content-center">
              <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
              &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
            </div>

          </form>
        </div>
        <div v-else>
          <br/><br/>
          <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
        </div>
      </div>

    </template>
    <script>
      import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
      import filterValidationMixin from '../mixins/filter_validation_mixin'
      import {mapState} from "vuex";
      import numericValidationMixin from '../mixins/numeric_validation_mixin'
      import jsonValidationMixin from '../mixins/json_validation_mixin'
      import JsonTagListEditor from './JsonTagListEditor.vue'
      import JsonObjectListEditor from './JsonObjectListEditor.vue'

      export default {
        name: 'tenant_config',
        mixins: [filterValidationMixin, numericValidationMixin, jsonValidationMixin],
        components: {
          JsonTagListEditor,
          JsonObjectListEditor,
        },

        data() {
          return {
            group_name: 'general',
            add_yard_model: {},
            manage_sos_yards: false,
            model: {},
            general_model: {},
            general_advanced_model: {},
            toggle: {},
            summary: {},
            loading: true,
            isNotSysadmin: false,
            isSamaraType: false,
            yardsLength: 0,
            objectKeyList: [],
            boolean_options: [
              { text: 'True', value: 'True' },
              { text: 'False', value: 'False' },
            ],
            auto_verify_columns: [
              { key: 'base', label: 'Base', placeholder: '* for wildcard' },
              { key: 'start_minutes', label: 'Start Minutes', type: 'number', placeholder: 'max diff' },
              { key: 'end_minutes', label: 'End Minutes', type: 'number', placeholder: 'max diff' },
              { key: 'total_minutes', label: 'Total Minutes', type: 'number', placeholder: 'max diff' },
            ],
            jsonFieldToggleMap: {
              actuals_base_config: 'isAdvVisible',
              actuals_outbound_base_config: 'isAdvVisible',
              actuals_outbound_auto_verify_config: 'isAdvVisible',
            },
          }
        },
        async mounted() {
          this.load_data()
        },
        methods: {
          async load_data() {
            this.loading = true
            try {
              const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
              this.summary = data.summary
              this.model = data.results

              try {
                const entries = Object.entries(this.model);
                for (let [key, value] of entries) {
                  if (this.isArrayType(value) || this.isPlainObject(value, key)) {
                    let setting = JSON.stringify(value)
                    //console.log('found plain object or array: key:' + key + ' value: ' + setting);
                    this.model[key] = setting
                    this.objectKeyList.push(key)
                  }
                }
              } catch (e) {
                console.log('error looping through keys', e)
              }

            } catch(e) {
              this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
            }

            this.loading = false
          },
          async save_config() {
            try {
              if (this.hasJsonErrors()) {
                this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
                this.expandAndScrollToJsonError()
                return
              }
              window.scrollTo(0,0);

              for (const objkey of this.objectKeyList) {
                try {
                  if (this.model[objkey] && this.model[objkey].trim && this.model[objkey].trim() !== '') {
                    let setting = JSON.parse(this.model[objkey])
                    this.model[objkey] = setting
                  }
                } catch (e) {
                  this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
                  this.expandAndScrollToJsonError()
                  this.load_data()
                  return
                }
              }

              this.$emit('showAlert', 'Saving Changes', 'info',5000)
              await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
              this.load_data()
              this.$emit('showAlert', 'Configuration Saved', 'success',5000)
            } catch(e) {
              this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
            }
          },
          set_tenant_id(id) {
            this.user.tenant = id
            this.load_data()
          },
          update_toggle_div(item,field,setting) {
            if (!item[field] && setting) {
              item[field] = !item[field];
              this.$forceUpdate();
            } else if (item[field] && !setting) {
              item[field] = !item[field];
              this.$forceUpdate();
            }
          },
          toggle_div(item,field) {
            item[field] = !item[field];
            this.$forceUpdate();
          },
          isPlainObject(value, key) {
            //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
            let objtype = (typeof value)
            if (objtype == "object") {
              if (value != null && !Array.isArray(value)) {
                return true
              }
              return false
            }
          },
          isArrayType(value) {
            return Array.isArray(value)
          },
        } ,
        computed:{
          ...mapState({
            user: state => state.profile.user
          }),
          is_admin() {
            return this.user.role === 'admin'
          },
          telematics_type() {
            return this.user.telematics_types[this.user.tenant]
          },
          tenant_type() {
            return this.user.types[this.user.tenant]
          }
        },
        watch: {
          user: {
            deep: true,
            handler() {
              this.load_data()
            }
          }
        }
      }
    </script>
    <style>
      @import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
    </style>

